import React, { useState } from "react";
import "./header.css";

function Header({ setActiveComponent }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuClick = (component) => {
    setActiveComponent(component);
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <>
      <header className="main-header">
        <div className="header-logo-title">
          <button onClick={() => handleMenuClick("visualizador")} style={{border: 'none', background: 'none', cursor: 'pointer'}}>
            <img src="/images/DRAGEXT2.png" alt="Logo" className="header-logo" />
          </button>
        </div>
        <div className="header-title-center">
          <h1 className="header-title">BITDRAGEX</h1>
        </div>
        {/* Botón hamburguesa solo visible en móvil */}
        <button
          className={`hamburger-btn${menuOpen ? " open" : ""}`}
          onClick={toggleMenu}
          aria-label="Abrir menú"
        >
          <span className="hamburger-bar"></span>
          <span className="hamburger-bar"></span>
          <span className="hamburger-bar"></span>
        </button>
        <nav className={`header-menu${menuOpen ? " open" : ""}`}>
          <ul>
            <li className="liop">
              <button onClick={() => handleMenuClick("visualizador")} style={{border: 'none', background: 'none', color: 'inherit', cursor: 'pointer'}}>BitDragex</button>
            </li>
            <li className="liop">
              <button onClick={() => handleMenuClick("articulos")} style={{border: 'none', background: 'none', color: 'inherit', cursor: 'pointer'}}>About Tbtc3</button>
            </li>
            <li className="liop">
              <button onClick={() => handleMenuClick("visualizador")} style={{border: 'none', background: 'none', color: 'inherit', cursor: 'pointer'}}>Swap</button>
            </li>
            <li className="liop">
              <button onClick={() => handleMenuClick("burn")} style={{border: 'none', background: 'none', color: 'inherit', cursor: 'pointer'}}>Bridge</button>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}

export default Header;